import React, { useContext } from 'react';
// eslint-disable-next-line yola/import/no-extraneous-dependencies
import { FloatingArrow, FloatingPortal } from '@floating-ui/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PopoverContext from '../../context';
import Paragraph from '../../../paragraph';
import getTextAppearances from './helpers/get-text-appearances';
import { APPEARANCES } from '../../constants';

const PopoverContent = ({ children = null, className = '' }) => {
  const {
    isVisible,
    title,
    description,
    width,
    hotkey,
    appearance,
    imgSrc,
    refs,
    floatingStyles,
    arrowRef,
    context,
    getFloatingProps,
  } = useContext(PopoverContext);

  if (!isVisible) {
    return null;
  }

  const classes = classNames(
    'ws-ui-popover-content',
    `ws-ui-popover-content--${appearance}`,
    className
  );

  const { titleAppearance, hotkeyAppearance, descriptionAppearance } = getTextAppearances(
    title,
    appearance
  );

  return (
    <FloatingPortal>
      <div
        ref={refs.setFloating}
        className={classes}
        style={{ ...floatingStyles, width }}
        {...getFloatingProps()}
      >
        {imgSrc && <img src={imgSrc} className="ws-ui-popover-content__img" alt="" />}
        {title && (
          <div className="ws-ui-popover-content__header">
            <div className="ws-ui-popover-content__title">
              <Paragraph appearance={titleAppearance}>
                <b>{title}</b>
              </Paragraph>
            </div>
            {hotkey && (
              <div className="ws-ui-popover-content__hotkey">
                <Paragraph size="small" appearance={hotkeyAppearance}>
                  {hotkey}
                </Paragraph>
              </div>
            )}
          </div>
        )}
        {description && (
          <Paragraph size="small" appearance={descriptionAppearance}>
            {description}
          </Paragraph>
        )}

        {children}
        <FloatingArrow
          ref={arrowRef}
          context={context}
          strokeWidth={1}
          height={5}
          width={10}
          fill="var(--bg-color)"
          {...(appearance === APPEARANCES.light && { stroke: 'var(--border-color)' })}
        />
      </div>
    </FloatingPortal>
  );
};

PopoverContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PopoverContent;
